import { render, staticRenderFns } from "./SocialAppointment.vue?vue&type=template&id=a2b763e2&"
import script from "./SocialAppointment.vue?vue&type=script&lang=js&"
export * from "./SocialAppointment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports